// extracted by mini-css-extract-plugin
export default {"choroplethMap":"ChoroplethMap_choroplethMap__yIXmU"};